import React from 'react';
import { useRecoilValue } from 'recoil';
import { Box, Container, Paper, TextField } from '@material-ui/core';
import { TokensDto } from '@oh-auth/dto/lib';

import { tokensState } from '../../features/auth';

export function TokenReader() {
	const tokens = useRecoilValue(tokensState) as TokensDto;

	return (
		<Container component="main">
			<Paper>
				<Box flexDirection="column" alignItems="center">
					<TextField
						variant="outlined"
						fullWidth
						multiline
						value={tokens.access_token}
					/>
				</Box>
			</Paper>
		</Container>
	);
}
